import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { Switch, Breadcrumbs, FormControlLabel, TextField } from '@mui/material';
import { Label, Input, Container } from "reactstrap";
import { GetSchema, email_required, string_required, date_picker, at_least_one_permission } from '../../../js/Base/ValidationSchema';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { InputField } from '../../../components/Common/FormikField/InputField';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import toastAlert from '../../../js/Base/ToastAlert';
import { GreenSwitch } from '../../../components/Common/GreenSwitch';
import TimezoneSelect from "react-timezone-select";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { createCompanyLicense } from '../../../api/keyApi';

export default function SendAuthCard() {
  const [license, setLicense] = useState(null);

  const initialValues = {
    email: '',
    expiry_date: '',
    permissions: '',
  };

  const formSchema = GetSchema({
    email: email_required(),
    expiry_date: date_picker(),
    permissions:at_least_one_permission(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const data = await createCompanyLicense(values);
      if (data.success) {
        setLicense(data.keys);
        toastAlert.autoClose(true).showSuccess("建立成功");
      } else {
        toastAlert.autoClose(true).showError("建立失敗，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("建立失敗，請稍後再試");
    } finally {
      setSubmitting(false);
    }
  };

  const titleStyle = {
    fontSize: '12px',
    color: '#323232',
    fontWeight: 'bold',
    marginTop: '20px',
    marginBottom: '6px',
    fontFamily: 'Noto Sans, sans-serif'
  };

  const checkbox_style = {
    borderWidth: '1px',
    width: '20px',
    height: '20px',
    fontSize: '12px',
    color: '#323232',
  };

  return (
    <React.Fragment>
      <Container className="mt-2">
        <div style={{ marginRight: '20px' }}>
          <Breadcrumbs
            className="link-area"
            style={{ padding: "0 0 20px 0", fontWeight: 'bold'}}
            separator={<NavigateNextIcon style={{ fontSize: '20px', fontWeight: 'bold' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/admin-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>網站管理員設定</p>
            </Link>
            <Link to="/send-auth-key" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>系統授權管理</p>
            </Link>
          </Breadcrumbs>

        <Card className="CompanyManagement" style={{ marginBottom: '20px'}}>
          <Card.Header style={{ backgroundColor: 'transparent' }}>
            <strong style={{ fontSize:'16px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>系統授權管理</strong>
          </Card.Header>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={formSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
              <Form>
                <Card.Body style={{ paddingTop: '5px', paddingBottom: '0px' }}>
                  <Row>
                    <Col md={6}>
                      <p style={titleStyle}>授權</p>
                      <div style={{ display: "flex", alignItems: "center", gap: "35px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Field name="permissions.cloud_native">
                            {({ field, form }) => (
                              <input
                                type="checkbox"
                                checked={field.value || false}
                                onChange={(e) =>
                                  form.setFieldValue("permissions.cloud_native", e.target.checked)
                                }
                                style={checkbox_style}
                              />
                            )}
                          </Field>
                          <span className="checkbox" style={{ fontFamily: "Noto Sans, sans-serif" }}>
                            雲原生
                          </span>
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <Field name="permissions.crowdstrike">
                            {({ field, form }) => (
                              <input
                                type="checkbox"
                                checked={field.value || false}
                                onChange={(e) =>
                                  form.setFieldValue("permissions.crowdstrike", e.target.checked)
                                }
                                style={checkbox_style}
                              />
                            )}
                          </Field>
                          <span className="checkbox" style={{ fontFamily: "Noto Sans, sans-serif" }}>
                            CrowdStrike
                          </span>
                        </label>
                      </div>
                      <ErrorMessage name="permissions">
                        {(msg) => <span className="text-danger" style={{ fontSize: "14px" }}>{msg}</span>}
                      </ErrorMessage>
                    </Col>

                    <Col md={6}>
                      <p
                        className="form-title mb-0"
                        style={{
                          fontSize: '12px',
                          color: '#323232',
                          fontWeight: 'bold',
                          marginTop: '20px',
                          fontFamily: 'Noto Sans, sans-serif',
                        }}
                        >
                        到期日(UTC)
                      </p>
                      <DatePicker
                        selected={values.expiry_date}
                        onChange={(date) => {
                          if (!date) return;
                          const dateOnly = new Date(Date.UTC(
                            date.getFullYear(),
                            date.getMonth(),
                            date.getDate()
                          ));
                      
                          setFieldValue("expiry_date", dateOnly.toISOString().slice(0, 10));
                        }}
                        dateFormat="yyyy-MM-dd"
                        className="form-control expiry-date-picker"
                      />
                      <ErrorMessage name="expiry_date">
                        {(msg) => <span className="text-danger" style={{ fontSize: "14px" }}>{msg}</span>}
                      </ErrorMessage>
                    </Col>
                    <Col md={6}/>
                    <Col md={6}>
                      <InputFormFiled
                        title="系統工程師帳號"
                        className="input-field custom-select"
                        name="email"
                        type="text"
                        invalid={errors.email && touched.email}
                      />
                    </Col>
                    {/* <Col md={6}>
                      <InputFormFiled
                        title="公司名稱"
                        className="input-field custom-select"
                        name="name"
                        type="text"
                        invalid={errors.name && touched.name}
                      />
                    </Col> */}
                    {license && (
                      <Col md={12}>
                        <p
                          className="form-title mb-0"
                          style={{
                            fontSize: '12px',
                            color: '#323232',
                            fontWeight: 'bold',
                            marginTop: '20px',
                            fontFamily: 'Noto Sans, sans-serif',
                          }}
                          >
                          產品金鑰
                        </p>
                        <Field name="license">
                          {({ field }) => (
                            <Input
                              {...field}
                              id="license"
                              maxLength="200"
                              type="textarea"
                              rows="6"
                              readOnly={true}
                              value={license}
                              title="點擊複製"
                              style={{ cursor: "pointer", fontSize: "13px" }}
                              onClick={() => {
                                navigator.clipboard.writeText(license);
                                toastAlert.autoClose(true).showInfo("已複製");
                              }}
                            />
                          )}
                        </Field>
                      </Col>
                    )}
                  </Row>
                </Card.Body>
                <Card.Footer
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '50px',
                    paddingBottom: '28px',
                    paddingRight: '26px',
                    paddingTop: '20px',
                    backgroundColor: 'transparent',
                    height: '85px',
                  }}
                  >
                  <Button
                    type="button"
                    className="btn btn-cancel me-2"
                    onClick={() => {
                      resetForm();
                      setLicense(null);
                    }}
                    disabled={isSubmitting}
                  >
                    清空
                  </Button>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-custom"
                  >
                    產生
                  </Button>
                </Card.Footer>
              </Form>
            )}
          </Formik>
        </Card>
        </div>
      </Container>
    </React.Fragment>
  );
}
